import { render, staticRenderFns } from "./MdImportFromElementDialog.vue?vue&type=template&id=9d7960d0&scoped=true&"
import script from "./MdImportFromElementDialog.vue?vue&type=script&lang=js&"
export * from "./MdImportFromElementDialog.vue?vue&type=script&lang=js&"
import style0 from "./MdImportFromElementDialog.vue?vue&type=style&index=0&id=9d7960d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7960d0",
  null
  
)

export default component.exports